import React from 'react';
import { Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { requestUrl } from '@/constants/urls';

const RequestCell = ({ request }) => (
  <Table.Cell>
    {request?.code && (
    <Link to={requestUrl(request)} title={request.name}>
      {request.name}
    </Link>
    )}
  </Table.Cell>
);

export default RequestCell;
